import { render } from "./svg-close.vue?vue&type=template&id=1b44ddd0&scoped=true"
import script from "./svg-close.vue?vue&type=script&lang=ts"
export * from "./svg-close.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-1b44ddd0"

export default script